module.exports = __webpack_public_path__ + "img/error-state.d7039a61.png";